document.addEventListener("DOMContentLoaded", function() {

	const $ = jQuery.noConflict();

	if ($('body').hasClass('blog')) {

		$('.filter-posts').append('<input id="post-years-list" hidden /><input id="post-cat-list" hidden />');

		$('.wp-block-query ul li').each(function() {

			/*
			*  Get/Add data from WP query block
			*/

			// Add data-title tag data
			var title = $(this).children().find('.wp-block-post-title a').text().replace('& ', '').replace(/\s+/g, '-').toLowerCase();
			setTimeout(() => {
				$(this).attr('data-title',title);
			}, 500);

			// Get Cat class list string
			var cat_list_items = $(this).children().find('.taxonomy-category a').text().replace('& ', '').replace(/\s+/g, '-').toLowerCase();
			setTimeout(() => {
				$(this).attr('data-cat',cat_list_items);

				setTimeout(() => {
					$('#post-cat-list').addClass(cat_list_items);
				}, 500);

			}, 500);

			// Add data-date tag data & year
			var date = $(this).children().find('.wp-block-post-date time').attr('datetime');
			var year = date.split('-')[0];
			setTimeout(() => {
				$(this).attr('data-year',year);
				$(this).attr('data-date',date);

				setTimeout(() => {
					var years_list = $(this).attr('data-year');
			
					setTimeout(() => {
						$('#post-years-list').addClass(years_list);
					}, 500);
			
				}, 500);

			}, 500);

			// Add data-tag tag data
			var tag_list = $(this).children().find('.taxonomy-post_tag a');
			$(this).children().find('.taxonomy-post_tag').append('<input class="post-tag-list" hidden>');
			tag_list.each(function() { 
				var tag_list_items = $(this).text().replace('& ', '').replace(/\s+/g, '-').toLowerCase();
				setTimeout(() => {
					$(this).parent().find('.post-tag-list').addClass(tag_list_items);
					setTimeout(() => {
						$(this).parent().find('.post-tag-list').removeClass('post-tag-list');
					}, 200);
				}, 200);
			});
			setTimeout(() => {
				var tags = $(this).children().find('.taxonomy-post_tag input').attr('class');
				$(this).attr('data-tag',tags);
			}, 550);
			setTimeout(() => {
				var filter = $('.section__filter-posts_grid .filter-posts_tag ul');
				var filter_tags = $(this).attr('data-tag');
				//console.log(filter_tags);
				filter.addClass(filter_tags);
			}, 1500);
		});
		
		setTimeout(() => {

			setTimeout(() => {
			var CatClassList = $('#post-cat-list').attr('class');
				// Creating Tag class array by splitting class list string
				var CatClassArr = CatClassList.split(/\s+/);
				$.each(CatClassArr, function(index,val){
					$('.section__filter-posts_grid .filter-posts select.filter-posts_cat').append('<option class="cats-list-data i_' + index + '" value="' + val +'">'+val+'</option>');
				});
			}, 200);

			// Get Year class list string
			var YearClassList = $('#post-years-list').attr('class');
			// Creating Tag class array by splitting class list string
			var YearClassArr = YearClassList.split(/\s+/);
			$.each(YearClassArr, function(index,val){
				$('.section__filter-posts_grid .filter-posts select.filter-posts_year').append('<option class="years-list-data i_' + index + '" value="' + val +'">'+val+'</option>');
			});

			// Get Tag class list string
			var TagClassList = $('.section__filter-posts_grid .filter-posts_tag ul').attr('class');
			// Creating Tag class array by splitting class list string
			var TagClassArr = TagClassList.split(/\s+/);
			$.each(TagClassArr, function(index,value){
				$('.section__filter-posts_grid .filter-posts_tag ul').append('<li class="btn i_' + index + '" data-tag="'+ value +'" style="display: list-item;">'+ value +'</li>');
			});

		}, 2100);		
	}

	/*
	*  Filter data from WP query block
	*/

	// Filter by Categories
	$(document).delegate('select.filter-posts_cat', 'change', function() {

		$('.filter-posts_tag ul li').removeClass('active');
		$('select.filter-posts_year').val('all').trigger('change');
		$('#loadMore').fadeOut();
		var val = $(this).val();

		if(val == "all") {
			//$('.wp-block-query ul li').fadeOut();
			$('.wp-block-query ul li').slice(0,4).show();
			setTimeout(function() {				
				$('#loadMore').fadeIn();
			}, 500);
		} else {
			$(".wp-block-query ul li").fadeIn().filter(":not([data-cat*=" + val + "])").fadeOut();
			setTimeout(function() {
				$('#loadMore').fadeOut();
			}, 500);
		}
	});

	// Filter by Year
	$(document).delegate('select.filter-posts_year', 'change', function() {
		//$('select.filter-posts_cat').val('all_cats').trigger('change');
		$('.filter-posts_tag ul li').removeClass('active');
		$('#loadMore').fadeOut();
		var val = $(this).val();
		if(val == "all") {
			//$('.wp-block-query ul li').fadeOut();
			$('.wp-block-query ul li').slice(0,4).show();
			setTimeout(function() {				
				$('#loadMore').fadeIn();
			}, 500);
		} else {
			$(".wp-block-query ul li").fadeIn().filter(":not([data-year*=" + val + "])").fadeOut();
			setTimeout(function() {				
				$('#loadMore').fadeOut();
			}, 500);
		}
	});

	// Filter by Tags
	$(document).delegate('.filter-posts_tag .btn', 'click', function() {
		//$('select.filter-posts_cat').val('all_cats').trigger('change');
		$('select.filter-posts_year').val('all').trigger('change');
		var tag = $(this).attr("data-tag");
		$('.filter-posts_tag ul li').removeClass('active');
		$(this).addClass('active');
		$('.wp-block-query ul li').fadeIn().filter(':not([data-tag*=' + tag + '])').fadeOut();
		setTimeout(function() {
			$('#loadMore').fadeOut();
		}, 200);
	});

	$(document).delegate('.filter-posts_tag .btn[data-tag=all]', 'click', function() {
		$('.wp-block-query ul li').removeAttr('style').fadeOut();
		$('.filter-posts_tag ul li').removeClass('active');		
		setTimeout(function() {
			$('.wp-block-query ul li').slice(0,4).show();
			$('#loadMore').fadeIn();
		}, 500);
	});

	// Filter by Date (New/Old first)	
	$(document).delegate('select.filter-posts_date', 'change', function() {
		$('#loadMore').fadeOut();
		var val = $(this).val();
		if(val == 'old-first') {
			$('#news_loop ul.wp-block-post-template li, #loadMore').fadeOut();
			$('#news_loop ul.wp-block-post-template').html($('#news_loop ul.wp-block-post-template').find('li').get().reverse());			
			setTimeout(function() {
				$('.wp-block-query ul li').slice(0,4).show();
				$('#loadMore').fadeIn();
			}, 500);
		} else {
			setTimeout(function() {
				window.location.reload();
			}, 500);
		}
	});

	// Filter by Title (A-Z)
	
});